export default __webpack_public_path__ + "i18n/translations/translation-it.e4d921d1.json";